__webpack_require__.p = "/fiscal-policy-slot-machine/";